/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
export const colorNeed = 'rgba(35, 41, 111, 1)';

export const standartCoulomsNeed = [
  {
    type: 'normal',
    header: [
      {
        label: 'Date',
        key: 'attributes.createdAt',
        option: {
          type: 'date',
          formatedDate: true,
          format: 'DD/MM/YYYY',
        },
      },
      {
        label: 'Prénom',
        key: 'attributes.users_permissions_user.firstname',
      },
      {
        label: 'Nom',
        key: 'attributes.users_permissions_user.lastname',
      },
      {
        label: 'Sexe',
        key: 'attributes.users_permissions_user.gender',
      },
      {
        label: 'Âge',
        key: 'attributes.users_permissions_user.dayOfBirth',
        option: {
          type: 'date',
          formatedDate: true,
        },
      },
      {
        label: 'Diplôme',
        key: 'attributes.users_permissions_user.diploma',
      },
      {
        label: 'CP',
        key: 'attributes.users_permissions_user.postal_code',
      },
      {
        label: 'Email',
        key: 'attributes.users_permissions_user.email',
      },
      {
        label: 'téléphone',
        key: 'attributes.users_permissions_user.phone',
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'physiologie',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.physiological_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.physiological_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'Sécurité',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.security_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.security_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'appartenance H',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.horizontal_belonging_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.horizontal_belonging_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'appartenance V',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.vertical_belonging_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.vertical_belonging_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'accomplissement',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.accomplishment_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.accomplishment_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'réalisation de soi',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.self_realization_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.self_realization_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'spiritualité',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.spirituality_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.spirituality_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'double',
    header: [
      {
        label: 'éternité',
        attr: [
          {
            label: 'PERSO',
            key: 'attributes.eternity_perso',
          },
          {
            label: 'PRO',
            key: 'attributes.eternity_pro',
          },
        ],
      },
    ],
  },
  {
    type: 'single',
    header: [
      {
        label: 'OPT-IN',
        key: 'attributes.opt_in',
        option: {
          format: 'nonull',
        },
      },
    ],
  },
  {
    type: 'single',
    header: [
      {
        label: 'BC',
        key: 'attributes.realization_period',
      },
    ],
  },
  {
    type: 'action',
    withBorder: true,
    header: [
      {
        label: 'Actions',
        key: 'name3',
        option: {
          type: 'Action',
          listAction: ['delete'],
        },
      },
    ],
  },
];
